import React, { useState } from 'react';
import PublicChatWidget from '../components/PublicChatWidget';
import PublicCalendarWidget from '../components/PublicCalendarWidget';
import './WidgetPage.css';

const WidgetPage = () => {
    const [activeTab, setActiveTab] = useState('chat'); // 'chat' or 'calendar'

    return (
        <div className="widget-page-container">
            {/* Header / Tabs */}
            <div className="widget-tabs">
                <button
                    className={`widget-tab ${activeTab === 'chat' ? 'active' : ''}`}
                    onClick={() => setActiveTab('chat')}
                >
                    Chat with AI
                </button>
                <button
                    className={`widget-tab ${activeTab === 'calendar' ? 'active' : ''}`}
                    onClick={() => setActiveTab('calendar')}
                >
                    Book Appointment
                </button>
            </div>

            {/* Content Area */}
            <div className="widget-content">
                {activeTab === 'chat' && (
                    <div className="widget-chat-wrapper">
                        {/* We reuse PublicChatWidget but force it to be "open" and inline */}
                        <PublicChatWidget isEmbedded={true} />
                    </div>
                )}

                {activeTab === 'calendar' && (
                    <div className="widget-calendar-wrapper">
                        <PublicCalendarWidget />
                    </div>
                )}
            </div>
        </div>
    );
};

export default WidgetPage;
